/* global System */

export default {
  EstateOverview: () =>
    System.import(/* webpackChunkName: "EstateOverview" */ './index'),
}
